import React from 'react';
import { Form, Input, Select, Checkbox, Tree, Radio, Row, Col, Divider, message, Button } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { dicMerchantUserStatus } from '../../../../axios/dictionaries';

const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const { TreeNode } = Tree;
const RadioGroup = Radio.Group;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            title: '新增人员',
            id: '',
            inputWidth: 220,
            roleLists: [], //岗位列表容器
            departmentOptionLists: [], //部门列表
            isAdmin: 0, //是否为商户管理员 0:false, 1:true
            jurisdictionData: [],
            checkedKeys: [], //选中的房源
            shouldPasswordRequired: true, //控制密码required
            passwordType: 'password',
        }
    }

    render() {
        let { visible, form: { getFieldDecorator }, departmentList } = this.props;
        let { loading,
            title,
            data,
            inputWidth,
            roleLists,
            departmentOptionLists,
            isAdmin,
            jurisdictionData,
            checkedKeys,
            shouldPasswordRequired,
            passwordType
        } = this.state;

        const footer = () => {
            if (this.props.disabled ) return <Button onClick={this.handleCancel}>关闭</Button>
            return (
                isAdmin == 0 ? null : <div> <Button onClick={this.handleCancel}>取消</Button></div>
            )
        }

        return <ModalDom
            title={ this.props.disabled ? '详情' : title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            width={"800px"}
            onCancel={this.handleCancel}
            footer={
                footer()
            }
               >
            <div className="custom" style={{
                marginTop: '-18px'
            }}
            >
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    className="min-height "
                >
                    <Row>
                        {
                            isAdmin == 1 ?

                                <Col span={24}>
                                    <DetailTitle title="基本信息" />
                                    <CustomRow>
                                        <CustomCol label="姓名：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.name}</div>
                                        </CustomCol>
                                        <CustomCol label="手机：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.phone}</div>
                                        </CustomCol>

                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="密码：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }} />
                                        </CustomCol>
                                        <CustomCol label="使用状态：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.status == 1 ? "正常" : "停用"}</div>
                                        </CustomCol>

                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol label="部门：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.departmentName}</div>
                                        </CustomCol>
                                        <CustomCol label="分配岗位：" labelStyle={{ width: '100px' }}>
                                            <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.roleName}</div>
                                        </CustomCol>
                                    </CustomRow>
                                </Col>
                                :
                                <Col span={24}>
                                    <DetailTitle title="基本信息" />
                                    <CustomRow>
                                        <CustomCol label="姓名">
                                            {getFieldDecorator('name', {
                                                rules: [{
                                                    required: true, message: '请输入姓名',
                                                }],
                                                initialValue: data.name
                                            })(
                                                <Input
                                                    placeholder={'请输入'}

                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol label="手机">
                                            {getFieldDecorator('phone', {
                                                rules: [{
                                                    required: true, message: '请输入手机',
                                                }],
                                                initialValue: data.phone
                                            })(
                                                <Input
                                                    placeholder={'请输入'}

                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>

                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol label="密码" required={shouldPasswordRequired ? undefined : false}>
                                            {getFieldDecorator(passwordType, {
                                                rules: [{
                                                    required: shouldPasswordRequired, message: '请输入密码',
                                                }],
                                            })(
                                                <Input
                                                    type="password"
                                                    placeholder={'请输入'}

                                                    autoComplete={'off'}
                                                />
                                            )}
                                        </CustomCol>
                                        <CustomCol label="使用状态">
                                            {getFieldDecorator('status', {
                                                rules: [{
                                                    required: true, message: '请选择使用状态',
                                                }],
                                                initialValue: data.status || 1
                                            })(
                                                <Select
                                                    showSearch

                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                >
                                                    {dicMerchantUserStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol label="部门">
                                            {getFieldDecorator('merchantDepartmentId', {
                                                rules: [{
                                                    required: true,
                                                    message: '请选择部门'
                                                }],
                                                initialValue: data.merchantDepartmentId
                                            })(
                                                <Select
                                                    showSearch

                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                >
                                                    {departmentOptionLists.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                                </Select>
                                            )}
                                        </CustomCol>
                                        <CustomCol label="分配岗位">
                                            {getFieldDecorator('roleId', {
                                                rules: [{
                                                    required: true,
                                                    message: '请选择分配岗位'
                                                }],
                                                initialValue: data.roleId
                                            })(
                                                <Select
                                                    showSearch

                                                    placeholder="请选择"
                                                    optionFilterProp={'children'}
                                                >
                                                    {roleLists.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                </Col>
                        }

                    </Row>

                    <DetailTitle title="管理房源" />
                    {
                        jurisdictionData.length
                            ? <Tree
                                loadData={this.onLoadData}
                                multiple
                                checkable
                                onCheck={
                                    (checkedKeys) => {
                                        this.setState({ checkedKeys });
                                    }
                                }
                                style={{
                                    maxHeight: "200px",
                                    overflowY: "scroll"
                                }}
                                checkedKeys={checkedKeys}
                              >
                                {this.renderTreeNodes(jurisdictionData)}
                            </Tree>
                            : <div style={{ textAlign: 'center' }}>暂无数据</div>
                    }
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, jurisdictionData: [], checkedKeys: [], title: "新增人员" })
        this.defaultcheckedKeys = [];
    }
    defaultcheckedKeys = []

    initPack() {

        this.setState({ loading: true });
        postFrom({
            url: config.API_merchantuserdataauthority_findBuildingAndHouse,
            data: {}
        }).then(res => {
            let jurisdictionData = [];
            jurisdictionData = res.buildings.map((item, index) => {
                let newItem = { title: item.name, idDispose: `building${item.id}` };
                let children = res.houses.filter((item2, index) => {
                    return item2.buildingId === item.id
                });
                children.sort((a, b) => a.floor - b.floor); //针对楼层排序

                let floor = [];
                children.forEach(el => { //生成出分楼层房号的数组
                    let value = floor.find(item => item.title === `楼层：${el.floor}`);
                    if (value) {
                        value.children.push({ title: `房号：${el.roomNo}`, idDispose: `houseId${el.id},${el.buildingId}`, isChild: true })
                    } else {
                        floor.push({
                            title: `楼层：${el.floor}`,
                            idDispose: `floor${el.floor}${el.id}`,
                            children: [
                                { title: `房号：${el.roomNo}`, idDispose: `houseId${el.id},${el.buildingId}`, isChild: true }
                            ]
                        })
                    }
                })
                floor.forEach((el => { //针对房号排序
                    el.children.sort((a, b) => a.title.slice(3) - b.title.slice(3));
                }))

                newItem.children = floor;
                return newItem
            })

            this.setState({ jurisdictionData, loading: false });
        }).catch(err => {
            message.error(err.message || '获取商户下所有楼盘数据失败');
            this.setState({ loading: false });
        });
    }



    loadPack = ({ id, platformisAdmin }) => {

        this.setState({ loading: true, title: "编辑人员", id });
        let data = { merchantUserId: id };
        postFrom({
            url: config.API_merchantuser_getById,
            data,
        }).then(res => {
            let checkedKeys = [];
            checkedKeys = res.merchantUserDataAuthority.map((item, index) => {
                return `houseId${item.houseId},${item.buildingId}`;
            })
            this.defaultcheckedKeys = res.merchantUserDataAuthority; //当前已被选中的项目
            this.setState({ data: res, loading: false, isAdmin: res.isAdmin, checkedKeys }, () => {
                if (platformisAdmin == 1) {
                    this.setState({
                        isAdmin: platformisAdmin
                    });
                }
            });

        }).catch(err => {

            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });

        this.loadDepartmentQuery(this.props.parentMerchantId);
        // this.initPack();
    }

    loadDepartmentQuery = (nowmerchantId, newAddAdmin) => { //部门列表查询

        this.setState({ loading: true });
        if (nowmerchantId) {
            postFrom({
                url: config.API_merchantdepartment_findAll,
                data: {
                    merchantId: nowmerchantId
                }
            }).then(res => {
                let result = [];
                for (let key in res) {
                    if (res[key].status == 1) {
                        result.push({
                            title: res[key]['name'],
                            value: res[key]['id']
                        })
                    }
                }
                this.setState({ departmentOptionLists: result, loading: false });
                if (newAddAdmin == 0) {
                    this.setState({ isAdmin: newAddAdmin })
                }
            }).catch(err => {
                message.error(err.message || '获取部门列表失败');
                this.setState({ loading: false });
            })
        }
    }

    loadRole = (newAdd) => { //岗位列表查询

        if (newAdd) {
            this.setState({ passwordType: 'password', shouldPasswordRequired: true })
        } else {
            this.setState({ passwordType: 'passwordNew', shouldPasswordRequired: false })
        }
        this.setState({ loading: true });
        postFrom({
            url: config.API_role_findAll, //应为岗位列表接口
            data: { owner: 2 }
        }).then(res => {
            let result = res.filter(item => item.status == 1);
            this.setState({ roleLists: result, loading: false });
        }).catch(err => {
            message.error(err.message || '获取岗位列表失败');
            this.setState({ loading: false });
        })
    };

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            if (!error) {
                this.setState({ loading: true });
                let data = {},
                    NOW_URL = '',
                    responText = '',
                    { checkedKeys } = this.state;

                let merchantUserDataAuthority = [];
                for (let i = 0; i < checkedKeys.length; i++) {
                    if (checkedKeys[i].startsWith('houseId')) {
                        let checkHandle = checkedKeys[i].slice(7).split(',');
                        merchantUserDataAuthority.push({ buildingId: checkHandle[1], houseId: checkHandle[0] })
                    }
                }
                for (let i = 0; i < merchantUserDataAuthority.length; i++) {
                    let item = this.defaultcheckedKeys.find((item, index) => {
                        return item.houseId === +merchantUserDataAuthority[i].houseId
                    })
                    if (item) {
                        merchantUserDataAuthority[i].id = item.id;
                    }
                }
                values.merchantUserDataAuthority = merchantUserDataAuthority;

                data = Object.assign({}, values, { merchantId: this.props.parentMerchantId });


                if (this.props.handlecreateOrEdit) {
                    NOW_URL = config.API_merchantuser_edit;
                    responText = '编辑';
                    data.id = this.state.id;
                } else {
                    NOW_URL = config.API_merchantuser_create;
                    responText = '新增'
                }
                post({
                    url: NOW_URL,
                    data,
                }).then(res => {
                    this.setState({ loading: false, jurisdictionData: [], checkedKeys: [], });
                    if (res && res.code) {
                        message.error(res.message || '接口异常')
                        return;
                    }
                    this.props.handleGetList();
                    this.handleCancel();
                    message.success(`${responText}成功`);
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false })
                })
            }
        })
    }





    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode selectable={false} title={item.title} key={item.idDispose} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.title} key={item.idDispose} dataRef={item} isLeaf={item.isChild} />;
        })
    }

}

export default Form.create()(Page);



// WEBPACK FOOTER //
// ./src/page/Merchant/components/UserAdd/index.js